module.exports = "<div style=\"position: fixed; left: 3em; bottom: 1em; z-index: 2; white-space: nowrap\"><uib-alert type=info close=dismissAlert() ng-show=\"!hasSeenAlert && newVersionAvailable\">{{ \"NEW_UPDATE_AVAILABLE_MESSAGE\" | translate }} <a style=\"margin:0 0.5em; cursor:pointer; font-weight:bold\" onclick=location.reload(true)>{{ \"NEW_UPDATE_AVAILABLE_ACTION\" | translate }}</a></uib-alert></div>";


//////////////////
// WEBPACK FOOTER
// ./js/version/versionChecker.html
// module id = 350
// module chunks = 0